import React from 'react';
import { Eye, Edit, ExternalLink } from 'lucide-react';
import { Customer } from '../../../types';
import Badge from '../../../components/ui/Badge';
import { userStatusVariant } from '../../../utils/badgeVariants';

export const CUSTOMER_COLUMNS = (
  highlightedId: number | null,
  loadingCustomer: boolean,
  handleViewDetails: (c: Customer) => void,
  handleEdit: (c: Customer) => void,
) => [
  {
    id: 'item',
    label: 'Customer',
    accessor: 'item',
    render: (c: Customer) => {
      const isHighlighted = highlightedId === c.id;
      return isHighlighted ? (
        <span
          data-customer-id={c.id}
          style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: '#15803d', fontWeight: 600 }}
        >
          <span style={{ width: 8, height: 8, background: '#22c55e', borderRadius: '50%', display: 'inline-block', animation: 'pulse 1s infinite' }} />
          {c.item}
        </span>
      ) : (
        <span data-customer-id={c.id} style={{ fontWeight: 500, color: 'var(--text-primary)' }}>{c.item}</span>
      );
    },
  },
  {
    id: 'client_id',
    label: 'Client ID',
    accessor: 'client_id',
    render: (c: Customer) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.client_id}</span>
    ),
  },
  {
    id: 'short_name',
    label: 'Short Name',
    accessor: 'short_name',
    render: (c: Customer) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.short_name}</span>
    ),
  },
  {
    id: 'monday_id',
    label: 'Monday ID',
    accessor: 'monday_id',
    render: (c: Customer) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.monday_id || '-'}</span>
    ),
  },
  {
    id: 'funding_type',
    label: 'Funding Type',
    accessor: 'funding_type',
    render: (c: Customer) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.funding_type || '-'}</span>
    ),
  },
  {
    id: 'status',
    label: 'Status',
    accessor: 'status',
    render: (c: Customer) => (
      <Badge variant={userStatusVariant(c.status)}>{c.status}</Badge>
    ),
  },
  {
    id: 'client_drive_name',
    label: 'Drive Name',
    accessor: 'client_drive_name',
    render: (c: Customer) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.client_drive_name || '-'}</span>
    ),
  },
  {
    id: 'google_drive_url',
    label: 'Google Drive',
    accessor: 'google_drive_url',
    render: (c: Customer) =>
      c.google_drive_url ? (
        <a
          href={c.google_drive_url}
          target="_blank"
          rel="noreferrer"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: '#2563eb', fontSize: 13 }}
        >
          <ExternalLink style={{ width: 12, height: 12 }} />
          View
        </a>
      ) : (
        <span style={{ color: 'var(--text-tertiary)', fontSize: 13 }}>-</span>
      ),
  },
  {
    id: 'actions',
    label: 'Actions',
    accessor: 'id',
    render: (c: Customer) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          onClick={() => handleViewDetails(c)}
          disabled={loadingCustomer}
          title="View Details"
          style={{ padding: '6px', color: '#2563eb', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(37,99,235,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Eye style={{ width: 16, height: 16 }} />
        </button>
        <button
          onClick={() => handleEdit(c)}
          disabled={loadingCustomer}
          title="Edit"
          style={{ padding: '6px', color: '#7c3aed', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(124,58,237,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Edit style={{ width: 16, height: 16 }} />
        </button>
      </div>
    ),
  },
];
